import { all_routes } from "../../../feature-module/router/all_routes";

// Permissions V2 — the first page a session may open, chosen from its granted
// key set. Shared by login and the company switch: a switch is a new session in
// another company, whose permissions can differ completely.
export const getLandingRoute = (permissionKeys: unknown, isPlatformAdmin = false): string => {
  // Tenancy §7.1: platform admins land on company management, not the
  // regular per-tenant permission-key routing below.
  if (isPlatformAdmin) return all_routes.tenants;

  const keys: string[] = Array.isArray(permissionKeys) ? permissionKeys : [];
  if (keys.length === 0) return all_routes.profile;

  const hasAnyUnder = (prefix: string) =>
    keys.some((k: string) =>
      (k.split("@")[0] || "").trim().toLowerCase().startsWith(prefix)
    );

  if (hasAnyUnder("dashboard.")) return all_routes.dealsDashboard;

  const routePriority = [
    { route: all_routes.contactList, prefix: "employees." },
    { route: all_routes.customers, prefix: "customers." },
    { route: all_routes.farmList, prefix: "farms." },
    { route: all_routes.teamList, prefix: "teams." },
    { route: all_routes.attendance, prefix: "attendance." },
    { route: all_routes.allReports, prefix: "reports." },
    { route: all_routes.audit, prefix: "audits." },
    { route: all_routes.vanPhoto, prefix: "vanphoto." },
    { route: all_routes.Vehicles, prefix: "vehicles." },
    { route: all_routes.rolesPermissions, prefix: "roles." },
  ];

  for (const item of routePriority) {
    if (hasAnyUnder(item.prefix)) return item.route;
  }

  return all_routes.profile;
};
